import './PieChartOverlays.css';
export var container = '_1jzpk0q0-2-0-1';